import axios from "axios";
import { formatApiError } from "@/lib/adminApi";

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/club`, withCredentials: true });

export { formatApiError };
export const joinClub = async (body) => (await api.post("/join", body)).data;
export const requestLoginLink = async (email) => (await api.post("/login-request", { email })).data;
export const verifyLoginToken = async (token) => (await api.post("/verify", null, { params: { token } })).data;
export const fetchMe = async () => (await api.get("/me")).data;
export const patchMe = async (body) => (await api.patch("/me", body)).data;
export const memberLogout = async () => (await api.post("/logout")).data;
export const fetchPublicOffers = async () => (await api.get("/offers")).data;
export const fetchPublicPartners = async () => (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/partners/public`)).data;

export const TERMS_TEXT =
  "Souhlasím s pravidly členství v CARSPA CLUB (pro prvních 500 členů zdarma, bez předplatného, kdykoliv zrušitelné; případná pozdější cena členství se stávajících členů netýká bez jejich souhlasu).";
export const MARKETING_TEXT =
  "Chci dostávat členské nabídky a novinky CARSPA CLUB e-mailem (lze kdykoliv odhlásit).";
